// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"533":"94f196a1","947":"be77114e"}[chunkId] + ".chunk.css";
};